import Link from "next/link";

import useAdyenResult from "../lib/checkout/payment/useAdyenResult";
import OrderInfo from "./OrderInfo/OrderInfo";
import Skeleton from "./Skeleton";

const CheckoutSummary = ({ locale }: { locale: string }) => {
  const { paymentdata, error } = useAdyenResult();

  const errorMessage =
    locale === "no"
      ? "Noe gikk galt. Prøv igjen, eller ta kontakt med support."
      : "Something went wrong, try again, or contact support.";
  if (error) {
    return <Link href="/giftcard">{errorMessage}</Link>;
  }

  if (paymentdata) {
    return <OrderInfo paymentdata={paymentdata} />;
  }
  return <Skeleton height="100vh" />;
};

export default CheckoutSummary;
